/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerProjection } from './PartnerProjection';
import {
    PartnerProjectionFromJSON,
    PartnerProjectionFromJSONTyped,
    PartnerProjectionToJSON,
    PartnerProjectionToJSONTyped,
} from './PartnerProjection';

/**
 * 
 * @export
 * @interface Opportunity
 */
export interface Opportunity {
    /**
     * 
     * @type {number}
     * @memberof Opportunity
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Opportunity
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof Opportunity
     */
    expectedRevenue: number;
    /**
     *
     * @type {number}
     * @memberof Opportunity
     */
    recurringRevenue: number;
    /**
     *
     * @type {number}
     * @memberof Opportunity
     */
    recurringPlanId?: number | null;
    /**
     *
     * @type {string}
     * @memberof Opportunity
     */
    typeOfSale: string;
    /**
     * 
     * @type {string}
     * @memberof Opportunity
     */
    salesFamily: string;
    /**
     * 
     * @type {number}
     * @memberof Opportunity
     */
    priority: number;
    /**
     * 
     * @type {string}
     * @memberof Opportunity
     */
    dateDeadline: string;
    /**
     * 
     * @type {number}
     * @memberof Opportunity
     */
    stageId: number;
    /**
     * 
     * @type {number}
     * @memberof Opportunity
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof Opportunity
     */
    userName: string;
    /**
     * 
     * @type {number}
     * @memberof Opportunity
     */
    salesEngineer: number;
    /**
     * 
     * @type {PartnerProjection}
     * @memberof Opportunity
     */
    crmBusinessProvider: PartnerProjection;
    /**
     * 
     * @type {string}
     * @memberof Opportunity
     */
    createDate: string;
    /**
     * 
     * @type {PartnerProjection}
     * @memberof Opportunity
     */
    partnerId?: PartnerProjection | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof Opportunity
     */
    orderIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof Opportunity
     */
    description: string;
}

/**
 * Check if a given object implements the Opportunity interface.
 */
export function instanceOfOpportunity(value: object): value is Opportunity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('expectedRevenue' in value) || value['expectedRevenue'] === undefined) return false;
    if (!('recurringRevenue' in value) || value['recurringRevenue'] === undefined) return false;
    if (!('typeOfSale' in value) || value['typeOfSale'] === undefined) return false;
    if (!('salesFamily' in value) || value['salesFamily'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('dateDeadline' in value) || value['dateDeadline'] === undefined) return false;
    if (!('stageId' in value) || value['stageId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('userName' in value) || value['userName'] === undefined) return false;
    if (!('salesEngineer' in value) || value['salesEngineer'] === undefined) return false;
    if (!('crmBusinessProvider' in value) || value['crmBusinessProvider'] === undefined) return false;
    if (!('createDate' in value) || value['createDate'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function OpportunityFromJSON(json: any): Opportunity {
    return OpportunityFromJSONTyped(json, false);
}

export function OpportunityFromJSONTyped(json: any, ignoreDiscriminator: boolean): Opportunity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'expectedRevenue': json['expected_revenue'],
        'recurringRevenue': json['recurring_revenue'],
        'recurringPlanId': json['recurring_plan'] == null ? undefined : (Array.isArray(json['recurring_plan']) ? json['recurring_plan'][0] : json['recurring_plan']),
        'typeOfSale': json['type_of_sale'],
        'salesFamily': json['sales_family'],
        'priority': json['priority'],
        'dateDeadline': json['date_deadline'],
        'stageId': json['stage_id'],
        'userId': json['user_id'],
        'userName': json['user_name'],
        'salesEngineer': json['sales_engineer'],
        'crmBusinessProvider': PartnerProjectionFromJSON(json['crm_business_provider']),
        'createDate': json['create_date'],
        'partnerId': json['partner_id'] == null ? undefined : PartnerProjectionFromJSON(json['partner_id']),
        'orderIds': json['order_ids'] == null ? undefined : json['order_ids'],
        'description': json['description'],
    };
}

export function OpportunityToJSON(json: any): Opportunity {
    return OpportunityToJSONTyped(json, false);
}

export function OpportunityToJSONTyped(value?: Opportunity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'expected_revenue': value['expectedRevenue'],
        'recurring_revenue': value['recurringRevenue'],
        'recurring_plan': value['recurringPlanId'],
        'type_of_sale': value['typeOfSale'],
        'sales_family': value['salesFamily'],
        'priority': value['priority'],
        'date_deadline': value['dateDeadline'],
        'stage_id': value['stageId'],
        'user_id': value['userId'],
        'user_name': value['userName'],
        'sales_engineer': value['salesEngineer'],
        'crm_business_provider': PartnerProjectionToJSON(value['crmBusinessProvider']),
        'create_date': value['createDate'],
        'partner_id': PartnerProjectionToJSON(value['partnerId']),
        'order_ids': value['orderIds'],
        'description': value['description'],
    };
}

